/**
 * Jméno modulu fetching. Slouží pro jednoznačnou identifikaci modulu.
 */
export const NAME = "fetching";

/** Konstanty typů akcí */
export const SET_FETCHING = `${NAME}/SET_FETCHING`;
